import React from 'react';
import { cn } from '../../utils/cn';

export type CallStatusType =
  | 'initiated'
  | 'ringing'
  | 'answered'
  | 'in_progress'
  | 'completed'
  | 'failed'
  | 'cancelled'
  | 'busy'
  | 'no_answer'
  | 'transferred'
  | 'escalated'
  | 'connected'
  | 'on-hold'
  | 'ended';

export interface CallStatusProps {
  status: CallStatusType;
  className?: string;
  showLabel?: boolean;
}

export const CallStatus: React.FC<CallStatusProps> = ({ status, className, showLabel = true }) => {
  const statusConfig = {
    initiated: {
      color: 'bg-blue-500',
      pulse: false,
      label: 'Initiated',
      icon: '●',
    },
    ringing: {
      color: 'bg-warning-500',
      pulse: true,
      label: 'Ringing',
      icon: '📞',
    },
    answered: {
      color: 'bg-success-500',
      pulse: false,
      label: 'Answered',
      icon: '✓',
    },
    in_progress: {
      color: 'bg-success-500',
      pulse: false,
      label: 'In Progress',
      icon: '●',
    },
    completed: {
      color: 'bg-gray-500',
      pulse: false,
      label: 'Completed',
      icon: '✓',
    },
    failed: {
      color: 'bg-error-500',
      pulse: false,
      label: 'Failed',
      icon: '⚠',
    },
    cancelled: {
      color: 'bg-gray-500',
      pulse: false,
      label: 'Cancelled',
      icon: '✕',
    },
    busy: {
      color: 'bg-warning-500',
      pulse: true,
      label: 'Busy',
      icon: '📞',
    },
    no_answer: {
      color: 'bg-gray-500',
      pulse: false,
      label: 'No Answer',
      icon: '✕',
    },
    transferred: {
      color: 'bg-info-500',
      pulse: false,
      label: 'Transferred',
      icon: '↗',
    },
    escalated: {
      color: 'bg-warning-500',
      pulse: false,
      label: 'Escalated',
      icon: '⬆',
    },
    connected: {
      color: 'bg-success-500',
      pulse: false,
      label: 'Connected',
      icon: '✓',
    },
    'on-hold': {
      color: 'bg-warning-500',
      pulse: true,
      label: 'On Hold',
      icon: '⏸',
    },
    ended: {
      color: 'bg-gray-500',
      pulse: false,
      label: 'Ended',
      icon: '⏹',
    },
  };

  const config = statusConfig[status];

  return (
    <div className={cn('flex items-center space-x-2', className)}>
      <div className={cn('w-3 h-3 rounded-full', config.color, config.pulse && 'animate-pulse')} />
      {showLabel && (
        <span className="text-sm font-medium text-gray-700 dark:text-gray-300">{config.label}</span>
      )}
    </div>
  );
};
